import Entity from "../../../class/abstract/Entity";
import Store from "../../_account/Stores/Store";
import License from "../../_account/Licenses/License";

class PaymentTerminal extends Entity {
    name = "";
    reference = "";
    target = "";
    interfaceType = "";
    brand = "";
    model = "";
    ipAddress = "";
    ipPort = 0;
    bltPort = "";
    usbPort = "";
    serialPort = "";
    serialBaudRate = 0;
    serialDataBits = 0;
    serialParity = "";
    serialStopBits = 0;
    serialFlowControl = "";
    allowsDisconnectedTerminal = null;
    allowsSimultaneousOperation = null;
    dontWaitAnswer = null;
    printClientReceipt = null;
    printMerchantReceipt = null;
    active = null;
    protocol = null;
    last_histo_author = null;
    store_id = null;
    store = {};
    license_id = null;
    license = {};
    licenseString = "";
    brandResume = "";
    connectionResume = "";

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                if(key === "store")
                    Reflect.set(this, key, new Store(datas[key]));
                else if(key === "license")
                    Reflect.set(this, key, new License(datas[key]));
                else
                    Reflect.set(this, key, datas[key]);
            }
        }

        this.defineBrandResume();
        this.defineConnectionResume();
        //this.defineLicenseString();
    }
    defineBrandResume() {
        if (this.brand === null || this.model === null)
            return;

        this.brandResume = this.brand + " - " + this.model;
    }
    defineConnectionResume() {
        this.connectionResume = "IP : " + this.ipAddress + " - Port : " + this.ipPort;
    }
    defineLicenseString() {
        if (this.license_id === null)
            this.licenseString = "Aucune";
        else
            this.licenseString = this.license.name + " (" + this.license.number + ")";
    }
}

export default PaymentTerminal;
